import React from 'react';
import Field from './Field'
import TypingTester from '@lib/TypingTester'
import Warning from '../../common/Warning';

export default class FieldNumber extends Field {
    constructor(props) {
        super(props)

        this.willBeUpdatedBySelf = false
        this.canAcceptValueUpdate = true
        this.tester = new TypingTester(250)
        this.state = {
            value: props.value || null
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({
            value: nextProps.value || null
        })
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (!this.willBeUpdatedBySelf) {
            if (nextState.value !== this.state.value && !this.canAcceptValueUpdate) {
                return false
            }
        }

        return (
            nextState.value !== this.state.value ||
            nextProps.value !== this.props.value ||
            nextProps.warning !== this.props.warning ||
            nextProps.readonly !== this.props.readonly ||
            nextProps.disabled !== this.props.disabled ||
            nextProps.text !== this.props.text
        )
    }

    onChange = e => {
        let val = e.target.value
        if (this.props.field.floatingPoint === false) {
            val = val.replace('.', '');
            val = val.replace(',', '');
        } else if (val && val.includes(',')) {
            val = val.replace(',', '.');
        }

        this.willBeUpdatedBySelf = true
        this.setState({value: val}, () => {
            this.willBeUpdatedBySelf = false
            this.canAcceptValueUpdate = false
        })

        // !!! Do not touch this !!!
        // !!! Store must be updated even if we're not done typing, yet !!!
        this.updateStoreValue(val)

        this.tester.record(() => {
            this.canAcceptValueUpdate = true
            this.props.onChange(val)
        })
    }

    renderInput = () => {
        let id = this.generateUniqueId()
        return (<React.Fragment>
            <input
                id={id}
                type="text"
                value={this.state.value || ''}
                onChange={this.onChange}
                className={this.props.warning ? `warning-${this.props.warning.color}` : ''}
                readOnly={this.props.readonly}
                disabled={this.props.disabled}
                onKeyUp={e => e.which === 9 ? this.onTabFocus(e) : {}}
            />
            {this.props.unitLabel && (<div className={`unit-label`}>{this.props.unitLabel}</div>)}
        </React.Fragment>)
    }

    renderReadOnly = () => {
        return <div className="text-field--readonly">{this.state.value} {this.props.unitLabel && (
            <span className={`unit-label--readonly`}>{this.props.unitLabel}</span>)}</div>
    }

    renderField() {
        return (
            <div className="configuration-editor-input-wrapper">
                {this.props.readonly ? this.renderReadOnly() : this.renderInput()}

                {this.props.warning && (
                    <React.Fragment>
                        <span className="input-warning-tooltip">
                            <Warning warning={this.props.warning}/>
                        </span>
                    </React.Fragment>
                )}
            </div>
        )
    }
}